/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CategoryCell_category$ref = any;
type CategoryCell_lists$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CategoryList_lists$ref: FragmentReference;
declare export opaque type CategoryList_lists$fragmentType: CategoryList_lists$ref;
export type CategoryList_lists = {|
  +categories: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: CategoryCell_category$ref,
      |}
    |}>
  |},
  +$fragmentRefs: CategoryCell_lists$ref,
  +$refType: CategoryList_lists$ref,
|};
export type CategoryList_lists$data = CategoryList_lists;
export type CategoryList_lists$key = {
  +$data?: CategoryList_lists$data,
  +$fragmentRefs: CategoryList_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "categories"
        ]
      }
    ]
  },
  "name": "CategoryList_lists",
  "selections": [
    {
      "alias": "categories",
      "args": null,
      "concreteType": "CategoryConnection",
      "kind": "LinkedField",
      "name": "__CategoryList_categories_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CategoryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Category",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CategoryCell_category"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CategoryCell_lists"
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = 'facb22d01f91f7ae9cdd418b68dd4f39';

module.exports = node;
